export enum MultipleOfferAvailability {
    ENABLED = 'ENABLED',
    DISABLED_FOR_SUPPLIER = 'DISABLED_FOR_SUPPLIER',
    DISABLED_FOR_CUSTOMER = 'DISABLED_FOR_CUSTOMER',
}
